import { render, staticRenderFns } from "./InvestList.vue?vue&type=template&id=e92f4c14&"
import script from "./InvestList.vue?vue&type=script&lang=js&"
export * from "./InvestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports